export enum FieldTypes {
  Tag = "Tag",
  BooleanSwitch = "BooleanSwitch",
  BooleanCheckBox = "BooleanCheckBox",
  User = "User",
  Date = "Date",
  Text = "Text",
  Number = "Number",
  Comments = "Comments",
  Url = "Url",
}

export enum NumFieldType {
  TagPicker = 0,
  Toggle = 1,
  Checkbox = 2,
  PeoplePicker = 3,
  Url = 4,
}
